/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class ObjectUtility {
  public static mergeObjects(obj1: any, obj2: any, basedKey: string): any {
    const result: any = {};

    for (const key in obj1) {
      if (Object.prototype.hasOwnProperty.call(obj1, key)) {
        result[key] = { ...result[key], ...obj1[key] };
      }
    }

    for (const key in obj2) {
      if (Object.prototype.hasOwnProperty.call(obj2, key)) {
        if (result[key]) {
          result[key][basedKey] = {
            ...result[key][basedKey],
            ...obj2[key][basedKey],
          };
        } else {
          result[key] = obj2[key];
        }
      }
    }
    return result;
  }
}
